export default "__VITE_ASSET__BjBGtVtT__"